import { useEffect } from 'react';
import { Button } from '@mui/material';
import ErrorOutlineRounded from '@mui/icons-material/ErrorOutlineRounded';
import { useRouteError } from 'react-router';
import { StatusScreen } from './StatusScreen';

const RELOAD_FLAG = 'app.chunk-reload';

function isStaleChunk(error: unknown) {
  const message = error instanceof Error ? error.message : String(error ?? '');
  return /dynamically imported module|Importing a module script failed|Failed to fetch dynamically/i.test(
    message,
  );
}

/**
 * Route-level error screen. After a new deploy, a tab still running the old
 * build asks for chunks that no longer exist: reload once to get the new build.
 */
export function RouteError() {
  const error = useRouteError();
  const stale = isStaleChunk(error);

  useEffect(() => {
    if (!stale) return;
    try {
      if (sessionStorage.getItem(RELOAD_FLAG)) return;
      sessionStorage.setItem(RELOAD_FLAG, '1');
    } catch {
      return;
    }
    window.location.reload();
  }, [stale]);

  useEffect(() => {
    if (!stale) console.error(error);
  }, [error, stale]);

  return (
    <StatusScreen
      icon={<ErrorOutlineRounded color="error" sx={{ fontSize: 48 }} />}
      title={stale ? 'Uma nova versão está disponível' : 'Algo deu errado nesta tela'}
      description={
        stale
          ? 'Recarregue a página para continuar.'
          : 'Tente de novo. Se o problema continuar, fale com o suporte.'
      }
      actions={
        <Button
          variant="contained"
          onClick={() => {
            try {
              sessionStorage.removeItem(RELOAD_FLAG);
            } catch {
              // ignore
            }
            window.location.reload();
          }}
        >
          Recarregar
        </Button>
      }
    />
  );
}
